import { PureComponent, type ReactNode } from 'react';
import type { ConnectedProps } from 'react-redux';

import type { JobsJobElasticSchemaWithId } from '@iconik-io/iconik-api/src/services/jobs';

import InputNumber from '../../fields/input_number/input_number';
import connector from './connector';

import styles from './priority_input.module.css';

type Props = ConnectedProps<typeof connector> & {
  job: JobsJobElasticSchemaWithId;
};

type State = {
  loading: boolean;
  value: number | undefined;
};

export class PriorityInput extends PureComponent<Props, State> {
  state = {
    loading: false,
    value: this.props.job.priority,
  };

  onChangeNumber = (val: number | undefined | null): void => {
    if (!val || val === this.state.value) {
      return;
    }
    if (val < 1 || val > 10) {
      this.setState({ value: this.props.job.priority });
      return;
    }
    this.setState({ loading: true, value: val });
    this.props
      .setJobPriority(this.props.job.id, Number(val))
      .finally(() => this.setState({ loading: false }));
  };

  render(): ReactNode {
    return (
      <InputNumber
        disabled={this.state.loading}
        type="number"
        placeholder="-"
        className={styles.number_input}
        min={1}
        max={10}
        step={1}
        value={this.state.value}
        onChange={this.onChangeNumber}
      />
    );
  }
}

export default connector(PriorityInput);
